export const humanizeBool = (bool) => (bool ? 'Yes' : 'No')
export const formatEmptyValue = (value) => (value ? value : '-')
